export default "__VITE_ASSET__DYDY9NAy__"